export default __webpack_public_path__ + "static/logo-fe3637bda4efc16fd589452d286a9b30.svg";